<script>
	import Check from '../../../assets/check.svelte';
	import Stop from '../../../assets/stop.svelte';
	export let height;
	export let fontSize;
	export let text;
	export let isJoined;
	export let disabled = false;
	let lineHeight, color, backgroundColor;

	$: if (fontSize) {
		lineHeight = fontSize * 1.4;
	}
	$: if (isJoined) {
		if (disabled) {
			backgroundColor = 'rgba(59, 170, 110, 0.12)';
			color = '#3BAA6E';
		} else {
			backgroundColor = '#2ac16f';
			color = '#ffffff';
		}
	} else {
		if (disabled) {
			backgroundColor = 'rgba(245, 104, 92, 0.12)';
			color = '#C35050';
		} else {
			backgroundColor = '#C35050';
			color = '#FFFFFF';
		}
	}
</script>

<button
	class="lobby-btn"
	style="--height: {height}px; --fontSize: {fontSize}px; --lineHeight: {lineHeight}px; --backgroundColor: {backgroundColor}; --color: {color}"
>
	<span class="lobby-btnText">
		{text}
	</span>
	<div class="lobby-btnsvg">
		{#if isJoined}
			<Check color={disabled ? '#3BAA6E' : 'white'} />
		{:else}
			<Stop color={disabled ? '#C35050' : 'white'} />
		{/if}
	</div>
</button>

<style>
	.lobby-btn {
		width: 100%;
		height: var(--height);
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		padding: 5px;
		margin: 0;
		background: var(--backgroundColor);
		border-style: none;
		border-radius: 19px;
		cursor: pointer;
	}
	.lobby-btnText {
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		font-size: var(--fontSize);
		line-height: var(--lineHeight);
		text-align: center;
		letter-spacing: 0.04em;
		margin: 0px 1px;
		margin-right: 10px;
		color: var(--color);
	}
	.lobby-btnsvg {
		width: 24px;
		height: 24px;
	}
</style>
